var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobileLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo-2021 2",
    clipPath: "url(#clip0_253_357)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M23.7057 11.2805L12.7214 0.297855C12.5306 0.107251 12.272 0.000183105 12.0022 0.000183105C11.7325 0.000183105 11.4738 0.107251 11.283 0.297855L0.298333 11.2805C0.10849 11.4716 0.00195312 11.7301 0.00195312 11.9995C0.00195313 12.269 0.10849 12.5274 0.298333 12.7186L11.2826 23.7012C11.4734 23.8918 11.7321 23.9989 12.0018 23.9989C12.2715 23.9989 12.5302 23.8918 12.721 23.7012L23.7057 12.7196C23.8961 12.5287 24.003 12.2701 24.003 12.0005C24.003 11.7309 23.8961 11.4723 23.7057 11.2814V11.2805ZM16.8385 15.8887H14.6067V11.0541L12.8708 14.1531H11.1355L9.39967 11.0541V15.8887H7.16784V7.21319H9.52356L12.0036 11.8001L14.4832 7.21319H16.839L16.8385 15.8887Z",
    fill: "#2D3280"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_253_357"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileLogo);
export default __webpack_public_path__ + "static/media/mobile-logo.13925f8729ece563cd2074dbda89db8d.svg";
export { ForwardRef as ReactComponent };